function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { SvelteComponent, init, safe_not_equal, append_styles, element, space, create_component, attr, null_to_empty, toggle_class, insert, append, mount_component, listen, is_function, transition_in, empty, group_outros, transition_out, check_outros, detach, destroy_component, add_render_callback, create_bidirectional_transition, run_all, create_slot, update_slot_base, get_all_dirty_from_scope, get_slot_changes, globals, noop, binding_callbacks } from 'svelte/internal';
import * as svelte from 'svelte';
import { createEventDispatcher } from 'svelte';
import { fade } from 'svelte/transition';
/* src/Modal.svelte generated by Svelte v3.46.4 */

var window_1 = globals.window;

function add_css(target) {
  append_styles(target, "svelte-g4wg3a", ".svelte-g4wg3a{box-sizing:border-box}.bg.svelte-g4wg3a{position:fixed;z-index:1000;top:0;left:0;display:flex;flex-direction:column;justify-content:center;width:100vw;height:100vh;background:rgba(0, 0, 0, 0.66)}.wrap.svelte-g4wg3a{position:relative;margin:2rem;max-height:100%}.window.svelte-g4wg3a{position:relative;width:40rem;max-width:100%;max-height:100%;margin:2rem auto;color:black;border-radius:0.5rem;background:white}.content.svelte-g4wg3a{position:relative;padding:1rem;max-height:calc(100vh - 4rem);overflow:auto}.close.svelte-g4wg3a{display:block;box-sizing:border-box;position:absolute;z-index:1000;top:1rem;right:1rem;margin:0;padding:0;width:1.5rem;height:1.5rem;border:0;color:black;border-radius:1.5rem;background:white;box-shadow:0 0 0 1px black;transition:transform 0.2s cubic-bezier(0.25, 0.1, 0.25, 1),\n      background 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);-webkit-appearance:none}.close.svelte-g4wg3a:before,.close.svelte-g4wg3a:after{content:'';display:block;box-sizing:border-box;position:absolute;top:50%;width:1rem;height:1px;background:black;transform-origin:center;transition:height 0.2s cubic-bezier(0.25, 0.1, 0.25, 1),\n      background 0.2s cubic-bezier(0.25, 0.1, 0.25, 1)}.close.svelte-g4wg3a:before{-webkit-transform:translate(0, -50%) rotate(45deg);-moz-transform:translate(0, -50%) rotate(45deg);transform:translate(0, -50%) rotate(45deg);left:0.25rem}.close.svelte-g4wg3a:after{-webkit-transform:translate(0, -50%) rotate(-45deg);-moz-transform:translate(0, -50%) rotate(-45deg);transform:translate(0, -50%) rotate(-45deg);left:0.25rem}.close.svelte-g4wg3a:hover{background:black}.close.svelte-g4wg3a:hover:before,.close.svelte-g4wg3a:hover:after{height:2px;background:white}.close.svelte-g4wg3a:focus{border-color:#3399ff;box-shadow:0 0 0 2px #3399ff}.close.svelte-g4wg3a:active{transform:scale(0.9)}.close.svelte-g4wg3a:hover,.close.svelte-g4wg3a:focus,.close.svelte-g4wg3a:active{outline:none}");
} // (401:0) {#if Component}


function create_if_block(ctx) {
  var div3;
  var div2;
  var div1;
  var t;
  var div0;
  var switch_instance;
  var div0_class_value;
  var div1_class_value;
  var div1_aria_label_value;
  var div1_aria_labelledby_value;
  var div1_transition;
  var div2_class_value;
  var div3_class_value;
  var div3_transition;
  var current;
  var mounted;
  var dispose;
  var if_block =
  /*state*/
  ctx[1].closeButton && create_if_block_1(ctx);
  var switch_value =
  /*Component*/
  ctx[2];

  function switch_props(ctx) {
    return {};
  }

  if (switch_value) {
    switch_instance = new switch_value(switch_props());
  }

  return {
    c: function c() {
      div3 = element("div");
      div2 = element("div");
      div1 = element("div");
      if (if_block) if_block.c();
      t = space();
      div0 = element("div");
      if (switch_instance) create_component(switch_instance.$$.fragment);
      attr(div0, "class", div0_class_value = "" + (null_to_empty(
      /*state*/
      ctx[1].classContent) + " svelte-g4wg3a"));
      attr(div0, "style",
      /*cssContent*/
      ctx[9]);
      toggle_class(div0, "content", !
      /*unstyled*/
      ctx[0]);
      attr(div1, "class", div1_class_value = "" + (null_to_empty(
      /*state*/
      ctx[1].classWindow) + " svelte-g4wg3a"));
      attr(div1, "role", "dialog");
      attr(div1, "aria-modal", "true");
      attr(div1, "aria-label", div1_aria_label_value =
      /*state*/
      ctx[1].ariaLabelledBy ? null :
      /*state*/
      ctx[1].ariaLabel || null);
      attr(div1, "aria-labelledby", div1_aria_labelledby_value =
      /*state*/
      ctx[1].ariaLabelledBy || null);
      attr(div1, "style",
      /*cssWindow*/
      ctx[8]);
      toggle_class(div1, "window", !
      /*unstyled*/
      ctx[0]);
      attr(div2, "class", div2_class_value = "" + (null_to_empty(
      /*state*/
      ctx[1].classWindowWrap) + " svelte-g4wg3a"));
      attr(div2, "style",
      /*cssWindowWrap*/
      ctx[7]);
      toggle_class(div2, "wrap", !
      /*unstyled*/
      ctx[0]);
      attr(div3, "class", div3_class_value = "" + (null_to_empty(
      /*state*/
      ctx[1].classBg) + " svelte-g4wg3a"));
      attr(div3, "style",
      /*cssBg*/
      ctx[6]);
      toggle_class(div3, "bg", !
      /*unstyled*/
      ctx[0]);
    },
    m: function m(target, anchor) {
      insert(target, div3, anchor);
      append(div3, div2);
      append(div2, div1);
      if (if_block) if_block.m(div1, null);
      append(div1, t);
      append(div1, div0);

      if (switch_instance) {
        mount_component(switch_instance, div0, null);
      }
      /*div1_binding*/


      ctx[48](div1);
      /*div2_binding*/

      ctx[49](div2);
      /*div3_binding*/

      ctx[50](div3);
      current = true;

      if (!mounted) {
        dispose = [listen(div1, "introstart", function () {
          if (is_function(
          /*onOpen*/
          ctx[13]))
            /*onOpen*/
            ctx[13].apply(this, arguments);
        }), listen(div1, "outrostart", function () {
          if (is_function(
          /*onClose*/
          ctx[14]))
            /*onClose*/
            ctx[14].apply(this, arguments);
        }), listen(div1, "introend", function () {
          if (is_function(
          /*onOpened*/
          ctx[15]))
            /*onOpened*/
            ctx[15].apply(this, arguments);
        }), listen(div1, "outroend", function () {
          if (is_function(
          /*onClosed*/
          ctx[16]))
            /*onClosed*/
            ctx[16].apply(this, arguments);
        }), listen(div3, "mousedown",
        /*handleOuterMousedown*/
        ctx[20]), listen(div3, "mouseup",
        /*handleOuterMouseup*/
        ctx[21])];
        mounted = true;
      }
    },
    p: function p(new_ctx, dirty) {
      ctx = new_ctx;

      if (
      /*state*/
      ctx[1].closeButton) {
        if (if_block) {
          if_block.p(ctx, dirty);

          if (dirty[0] &
          /*state*/
          2) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block_1(ctx);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(div1, t);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, function () {
          if_block = null;
        });
        check_outros();
      }

      if (switch_value !== (switch_value =
      /*Component*/
      ctx[2])) {
        if (switch_instance) {
          group_outros();
          var old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, function () {
            destroy_component(old_component, 1);
          });
          check_outros();
        }

        if (switch_value) {
          switch_instance = new switch_value(switch_props());
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, div0, null);
        } else {
          switch_instance = null;
        }
      }

      if (!current || dirty[0] &
      /*state*/
      2 && div0_class_value !== (div0_class_value = "" + (null_to_empty(
      /*state*/
      ctx[1].classContent) + " svelte-g4wg3a"))) {
        attr(div0, "class", div0_class_value);
      }

      if (!current || dirty[0] &
      /*cssContent*/
      512) {
        attr(div0, "style",
        /*cssContent*/
        ctx[9]);
      }

      if (dirty[0] &
      /*state, unstyled*/
      3) {
        toggle_class(div0, "content", !
        /*unstyled*/
        ctx[0]);
      }

      if (!current || dirty[0] &
      /*state*/
      2 && div1_class_value !== (div1_class_value = "" + (null_to_empty(
      /*state*/
      ctx[1].classWindow) + " svelte-g4wg3a"))) {
        attr(div1, "class", div1_class_value);
      }

      if (!current || dirty[0] &
      /*state*/
      2 && div1_aria_label_value !== (div1_aria_label_value =
      /*state*/
      ctx[1].ariaLabelledBy ? null :
      /*state*/
      ctx[1].ariaLabel || null)) {
        attr(div1, "aria-label", div1_aria_label_value);
      }

      if (!current || dirty[0] &
      /*state*/
      2 && div1_aria_labelledby_value !== (div1_aria_labelledby_value =
      /*state*/
      ctx[1].ariaLabelledBy || null)) {
        attr(div1, "aria-labelledby", div1_aria_labelledby_value);
      }

      if (!current || dirty[0] &
      /*cssWindow*/
      256) {
        attr(div1, "style",
        /*cssWindow*/
        ctx[8]);
      }

      if (dirty[0] &
      /*state, unstyled*/
      3) {
        toggle_class(div1, "window", !
        /*unstyled*/
        ctx[0]);
      }

      if (!current || dirty[0] &
      /*state*/
      2 && div2_class_value !== (div2_class_value = "" + (null_to_empty(
      /*state*/
      ctx[1].classWindowWrap) + " svelte-g4wg3a"))) {
        attr(div2, "class", div2_class_value);
      }

      if (!current || dirty[0] &
      /*cssWindowWrap*/
      128) {
        attr(div2, "style",
        /*cssWindowWrap*/
        ctx[7]);
      }

      if (dirty[0] &
      /*state, unstyled*/
      3) {
        toggle_class(div2, "wrap", !
        /*unstyled*/
        ctx[0]);
      }

      if (!current || dirty[0] &
      /*state*/
      2 && div3_class_value !== (div3_class_value = "" + (null_to_empty(
      /*state*/
      ctx[1].classBg) + " svelte-g4wg3a"))) {
        attr(div3, "class", div3_class_value);
      }

      if (!current || dirty[0] &
      /*cssBg*/
      64) {
        attr(div3, "style",
        /*cssBg*/
        ctx[6]);
      }

      if (dirty[0] &
      /*state, unstyled*/
      3) {
        toggle_class(div3, "bg", !
        /*unstyled*/
        ctx[0]);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      if (switch_instance) transition_in(switch_instance.$$.fragment, local);
      add_render_callback(function () {
        if (!div1_transition) div1_transition = create_bidirectional_transition(div1,
        /*currentTransitionWindow*/
        ctx[12],
        /*state*/
        ctx[1].transitionWindowProps, true);
        div1_transition.run(1);
      });
      add_render_callback(function () {
        if (!div3_transition) div3_transition = create_bidirectional_transition(div3,
        /*currentTransitionBg*/
        ctx[11],
        /*state*/
        ctx[1].transitionBgProps, true);
        div3_transition.run(1);
      });
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      if (switch_instance) transition_out(switch_instance.$$.fragment, local);
      if (!div1_transition) div1_transition = create_bidirectional_transition(div1,
      /*currentTransitionWindow*/
      ctx[12],
      /*state*/
      ctx[1].transitionWindowProps, false);
      div1_transition.run(0);
      if (!div3_transition) div3_transition = create_bidirectional_transition(div3,
      /*currentTransitionBg*/
      ctx[11],
      /*state*/
      ctx[1].transitionBgProps, false);
      div3_transition.run(0);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div3);
      if (if_block) if_block.d();
      if (switch_instance) destroy_component(switch_instance);
      /*div1_binding*/

      ctx[48](null);
      if (detaching && div1_transition) div1_transition.end();
      /*div2_binding*/

      ctx[49](null);
      /*div3_binding*/

      ctx[50](null);
      if (detaching && div3_transition) div3_transition.end();
      mounted = false;
      run_all(dispose);
    }
  };
} // (432:8) {#if state.closeButton}


function create_if_block_1(ctx) {
  var show_if;
  var current_block_type_index;
  var if_block;
  var if_block_anchor;
  var current;
  var if_block_creators = [create_if_block_2, create_else_block];
  var if_blocks = [];

  function select_block_type(ctx, dirty) {
    if (dirty[0] &
    /*state*/
    2) show_if = null;
    if (show_if == null) show_if = !!
    /*isFunction*/
    ctx[17](
    /*state*/
    ctx[1].closeButton);
    if (show_if) return 0;
    return 1;
  }

  current_block_type_index = select_block_type(ctx, [-1, -1, -1]);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c: function c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m: function m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx, dirty);

      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, function () {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];

        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
          if_block.c();
        } else {
          if_block.p(ctx, dirty);
        }

        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      current = false;
    },
    d: function d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
} // (435:10) {:else}


function create_else_block(ctx) {
  var button;
  var button_class_value;
  var mounted;
  var dispose;
  return {
    c: function c() {
      button = element("button");
      attr(button, "class", button_class_value = "" + (null_to_empty(
      /*state*/
      ctx[1].classCloseButton) + " svelte-g4wg3a"));
      attr(button, "aria-label", "Close modal");
      attr(button, "style",
      /*cssCloseButton*/
      ctx[10]);
      toggle_class(button, "close", !
      /*unstyled*/
      ctx[0]);
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);

      if (!mounted) {
        dispose = listen(button, "click",
        /*close*/
        ctx[18]);
        mounted = true;
      }
    },
    p: function p(ctx, dirty) {
      if (dirty[0] &
      /*state*/
      2 && button_class_value !== (button_class_value = "" + (null_to_empty(
      /*state*/
      ctx[1].classCloseButton) + " svelte-g4wg3a"))) {
        attr(button, "class", button_class_value);
      }

      if (dirty[0] &
      /*cssCloseButton*/
      1024) {
        attr(button, "style",
        /*cssCloseButton*/
        ctx[10]);
      }

      if (dirty[0] &
      /*state, unstyled*/
      3) {
        toggle_class(button, "close", !
        /*unstyled*/
        ctx[0]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(button);
      mounted = false;
      dispose();
    }
  };
} // (433:10) {#if isFunction(state.closeButton)}


function create_if_block_2(ctx) {
  var switch_instance;
  var switch_instance_anchor;
  var current;
  var switch_value =
  /*state*/
  ctx[1].closeButton;

  function switch_props(ctx) {
    return {
      props: {
        onClose:
        /*close*/
        ctx[18]
      }
    };
  }

  if (switch_value) {
    switch_instance = new switch_value(switch_props(ctx));
  }

  return {
    c: function c() {
      if (switch_instance) create_component(switch_instance.$$.fragment);
      switch_instance_anchor = empty();
    },
    m: function m(target, anchor) {
      if (switch_instance) {
        mount_component(switch_instance, target, anchor);
      }

      insert(target, switch_instance_anchor, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      if (switch_value !== (switch_value =
      /*state*/
      ctx[1].closeButton)) {
        if (switch_instance) {
          group_outros();
          var old_component = switch_instance;
          transition_out(old_component.$$.fragment, 1, 0, function () {
            destroy_component(old_component, 1);
          });
          check_outros();
        }

        if (switch_value) {
          switch_instance = new switch_value(switch_props(ctx));
          create_component(switch_instance.$$.fragment);
          transition_in(switch_instance.$$.fragment, 1);
          mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
        } else {
          switch_instance = null;
        }
      }
    },
    i: function i(local) {
      if (current) return;
      if (switch_instance) transition_in(switch_instance.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      if (switch_instance) transition_out(switch_instance.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(switch_instance_anchor);
      if (switch_instance) destroy_component(switch_instance, detaching);
    }
  };
}

function create_fragment(ctx) {
  var t;
  var current;
  var mounted;
  var dispose;
  var if_block =
  /*Component*/
  ctx[2] && create_if_block(ctx);
  var default_slot_template =
  /*#slots*/
  ctx[47]["default"];
  var default_slot = create_slot(default_slot_template, ctx,
  /*$$scope*/
  ctx[46], null);
  return {
    c: function c() {
      if (if_block) if_block.c();
      t = space();
      if (default_slot) default_slot.c();
    },
    m: function m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, t, anchor);

      if (default_slot) {
        default_slot.m(target, anchor);
      }

      current = true;

      if (!mounted) {
        dispose = listen(window_1, "keydown",
        /*handleKeydown*/
        ctx[19]);
        mounted = true;
      }
    },
    p: function p(ctx, dirty) {
      if (
      /*Component*/
      ctx[2]) {
        if (if_block) {
          if_block.p(ctx, dirty);

          if (dirty[0] &
          /*Component*/
          4) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block(ctx);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(t.parentNode, t);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, function () {
          if_block = null;
        });
        check_outros();
      }

      if (default_slot) {
        if (default_slot.p && (!current || dirty[1] &
        /*$$scope*/
        32768)) {
          update_slot_base(default_slot, default_slot_template, ctx,
          /*$$scope*/
          ctx[46], !current ? get_all_dirty_from_scope(
          /*$$scope*/
          ctx[46]) : get_slot_changes(default_slot_template,
          /*$$scope*/
          ctx[46], dirty, null), null);
        }
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      transition_in(default_slot, local);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      transition_out(default_slot, local);
      current = false;
    },
    d: function d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(t);
      if (default_slot) default_slot.d(detaching);
      mounted = false;
      dispose();
    }
  };
}

function bind(Component) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function ModalComponent(options) {
    return new Component(_objectSpread(_objectSpread({}, options), {}, {
      props: _objectSpread(_objectSpread({}, props), options.props)
    }));
  };
}

function instance($$self, $$props, $$invalidate) {
  var _$$props$$$slots = $$props.$$slots,
      slots = _$$props$$$slots === void 0 ? {} : _$$props$$$slots,
      $$scope = $$props.$$scope;
  var dispatch = createEventDispatcher();
  var baseSetContext = svelte.setContext;
  var _$$props$show = $$props.show,
      show = _$$props$show === void 0 ? null : _$$props$show;
  var _$$props$key = $$props.key,
      key = _$$props$key === void 0 ? 'simple-modal' : _$$props$key;
  var _$$props$ariaLabel = $$props.ariaLabel,
      ariaLabel = _$$props$ariaLabel === void 0 ? null : _$$props$ariaLabel;
  var _$$props$ariaLabelled = $$props.ariaLabelledBy,
      ariaLabelledBy = _$$props$ariaLabelled === void 0 ? null : _$$props$ariaLabelled;
  var _$$props$closeButton = $$props.closeButton,
      closeButton = _$$props$closeButton === void 0 ? true : _$$props$closeButton;
  var _$$props$closeOnEsc = $$props.closeOnEsc,
      closeOnEsc = _$$props$closeOnEsc === void 0 ? true : _$$props$closeOnEsc;
  var _$$props$closeOnOuter = $$props.closeOnOuterClick,
      closeOnOuterClick = _$$props$closeOnOuter === void 0 ? true : _$$props$closeOnOuter;
  var _$$props$styleBg = $$props.styleBg,
      styleBg = _$$props$styleBg === void 0 ? {} : _$$props$styleBg;
  var _$$props$styleWindowW = $$props.styleWindowWrap,
      styleWindowWrap = _$$props$styleWindowW === void 0 ? {} : _$$props$styleWindowW;
  var _$$props$styleWindow = $$props.styleWindow,
      styleWindow = _$$props$styleWindow === void 0 ? {} : _$$props$styleWindow;
  var _$$props$styleContent = $$props.styleContent,
      styleContent = _$$props$styleContent === void 0 ? {} : _$$props$styleContent;
  var _$$props$styleCloseBu = $$props.styleCloseButton,
      styleCloseButton = _$$props$styleCloseBu === void 0 ? {} : _$$props$styleCloseBu;
  var _$$props$classBg = $$props.classBg,
      classBg = _$$props$classBg === void 0 ? null : _$$props$classBg;
  var _$$props$classWindowW = $$props.classWindowWrap,
      classWindowWrap = _$$props$classWindowW === void 0 ? null : _$$props$classWindowW;
  var _$$props$classWindow = $$props.classWindow,
      classWindow = _$$props$classWindow === void 0 ? null : _$$props$classWindow;
  var _$$props$classContent = $$props.classContent,
      classContent = _$$props$classContent === void 0 ? null : _$$props$classContent;
  var _$$props$classCloseBu = $$props.classCloseButton,
      classCloseButton = _$$props$classCloseBu === void 0 ? null : _$$props$classCloseBu;
  var _$$props$unstyled = $$props.unstyled,
      unstyled = _$$props$unstyled === void 0 ? false : _$$props$unstyled;
  var _$$props$setContext = $$props.setContext,
      setContext = _$$props$setContext === void 0 ? baseSetContext : _$$props$setContext;
  var _$$props$transitionBg = $$props.transitionBg,
      transitionBg = _$$props$transitionBg === void 0 ? fade : _$$props$transitionBg;
  var _$$props$transitionBg2 = $$props.transitionBgProps,
      transitionBgProps = _$$props$transitionBg2 === void 0 ? {
    duration: 250
  } : _$$props$transitionBg2;
  var _$$props$transitionWi = $$props.transitionWindow,
      transitionWindow = _$$props$transitionWi === void 0 ? transitionBg : _$$props$transitionWi;
  var _$$props$transitionWi2 = $$props.transitionWindowProps,
      transitionWindowProps = _$$props$transitionWi2 === void 0 ? transitionBgProps : _$$props$transitionWi2;
  var _$$props$disableFocus = $$props.disableFocusTrap,
      disableFocusTrap = _$$props$disableFocus === void 0 ? false : _$$props$disableFocus;
  var defaultState = {
    ariaLabel: ariaLabel,
    ariaLabelledBy: ariaLabelledBy,
    closeButton: closeButton,
    closeOnEsc: closeOnEsc,
    closeOnOuterClick: closeOnOuterClick,
    styleBg: styleBg,
    styleWindowWrap: styleWindowWrap,
    styleWindow: styleWindow,
    styleContent: styleContent,
    styleCloseButton: styleCloseButton,
    classBg: classBg,
    classWindowWrap: classWindowWrap,
    classWindow: classWindow,
    classContent: classContent,
    classCloseButton: classCloseButton,
    transitionBg: transitionBg,
    transitionBgProps: transitionBgProps,
    transitionWindow: transitionWindow,
    transitionWindowProps: transitionWindowProps,
    disableFocusTrap: disableFocusTrap,
    unstyled: unstyled
  };

  var state = _objectSpread({}, defaultState);

  var Component = null;
  var background;
  var wrap;
  var modalWindow;
  var scrollY;
  var cssBg;
  var cssWindowWrap;
  var cssWindow;
  var cssContent;
  var cssCloseButton;
  var currentTransitionBg;
  var currentTransitionWindow;
  var prevBodyPosition;
  var prevBodyOverflow;
  var prevBodyWidth;
  var outerClickTarget;

  var camelCaseToDash = function camelCaseToDash(str) {
    return str.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase();
  };

  var toCssString = function toCssString(props) {
    return props ? Object.keys(props).reduce(function (str, key) {
      return "".concat(str, "; ").concat(camelCaseToDash(key), ": ").concat(props[key]);
    }, '') : '';
  };

  var isFunction = function isFunction(f) {
    return !!(f && f.constructor && f.call && f.apply);
  };

  var updateStyleTransition = function updateStyleTransition() {
    $$invalidate(6, cssBg = toCssString(Object.assign({}, {
      width: window.innerWidth,
      height: window.innerHeight
    }, state.styleBg)));
    $$invalidate(7, cssWindowWrap = toCssString(state.styleWindowWrap));
    $$invalidate(8, cssWindow = toCssString(state.styleWindow));
    $$invalidate(9, cssContent = toCssString(state.styleContent));
    $$invalidate(10, cssCloseButton = toCssString(state.styleCloseButton));
    $$invalidate(11, currentTransitionBg = state.transitionBg);
    $$invalidate(12, currentTransitionWindow = state.transitionWindow);
  };

  var toVoid = function toVoid() {};

  var onOpen = toVoid;
  var onClose = toVoid;
  var onOpened = toVoid;
  var onClosed = toVoid;

  var open = function open(NewComponent) {
    var newProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    $$invalidate(2, Component = bind(NewComponent, newProps));
    $$invalidate(1, state = _objectSpread(_objectSpread({}, defaultState), options));
    updateStyleTransition();
    disableScroll();
    $$invalidate(13, onOpen = function onOpen(event) {
      if (callback.onOpen) callback.onOpen(event);
      /**
      * The open event is fired right before the modal opens
      * @event {void} open
      */

      dispatch('open');
      /**
      * The opening event is fired right before the modal opens
      * @event {void} opening
      * @deprecated Listen to the `open` event instead
      */

      dispatch('opening'); // Deprecated. Do not use!
    });
    $$invalidate(14, onClose = function onClose(event) {
      if (callback.onClose) callback.onClose(event);
      /**
      * The close event is fired right before the modal closes
      * @event {void} close
      */

      dispatch('close');
      /**
      * The closing event is fired right before the modal closes
      * @event {void} closing
      * @deprecated Listen to the `close` event instead
      */

      dispatch('closing'); // Deprecated. Do not use!
    });
    $$invalidate(15, onOpened = function onOpened(event) {
      if (callback.onOpened) callback.onOpened(event);
      /**
      * The opened event is fired after the modal's opening transition
      * @event {void} opened
      */

      dispatch('opened');
    });
    $$invalidate(16, onClosed = function onClosed(event) {
      if (callback.onClosed) callback.onClosed(event);
      /**
      * The closed event is fired after the modal's closing transition
      * @event {void} closed
      */

      dispatch('closed');
    });
  };

  var close = function close() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!Component) return;
    $$invalidate(14, onClose = callback.onClose || onClose);
    $$invalidate(16, onClosed = callback.onClosed || onClosed);
    $$invalidate(2, Component = null);
    enableScroll();
  };

  var handleKeydown = function handleKeydown(event) {
    if (state.closeOnEsc && Component && event.key === 'Escape') {
      event.preventDefault();
      close();
    }

    if (Component && event.key === 'Tab' && !state.disableFocusTrap) {
      // trap focus
      var nodes = modalWindow.querySelectorAll('*');
      var tabbable = Array.from(nodes).filter(function (node) {
        return node.tabIndex >= 0;
      });
      var index = tabbable.indexOf(document.activeElement);
      if (index === -1 && event.shiftKey) index = 0;
      index += tabbable.length + (event.shiftKey ? -1 : 1);
      index %= tabbable.length;
      tabbable[index].focus();
      event.preventDefault();
    }
  };

  var handleOuterMousedown = function handleOuterMousedown(event) {
    if (state.closeOnOuterClick && (event.target === background || event.target === wrap)) outerClickTarget = event.target;
  };

  var handleOuterMouseup = function handleOuterMouseup(event) {
    if (state.closeOnOuterClick && event.target === outerClickTarget) {
      event.preventDefault();
      close();
    }
  };

  var disableScroll = function disableScroll() {
    scrollY = window.scrollY;
    prevBodyPosition = document.body.style.position;
    prevBodyOverflow = document.body.style.overflow;
    prevBodyWidth = document.body.style.width;
    document.body.style.position = 'fixed';
    document.body.style.top = "-".concat(scrollY, "px");
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';
  };

  var enableScroll = function enableScroll() {
    document.body.style.position = prevBodyPosition || '';
    document.body.style.top = '';
    document.body.style.overflow = prevBodyOverflow || '';
    document.body.style.width = prevBodyWidth || '';
    window.scrollTo(0, scrollY);
  };

  setContext(key, {
    open: open,
    close: close
  });
  var isMounted = false;
  svelte.onDestroy(function () {
    if (isMounted) close();
  });
  svelte.onMount(function () {
    $$invalidate(45, isMounted = true);
  });

  function div1_binding($$value) {
    binding_callbacks[$$value ? 'unshift' : 'push'](function () {
      modalWindow = $$value;
      $$invalidate(5, modalWindow);
    });
  }

  function div2_binding($$value) {
    binding_callbacks[$$value ? 'unshift' : 'push'](function () {
      wrap = $$value;
      $$invalidate(4, wrap);
    });
  }

  function div3_binding($$value) {
    binding_callbacks[$$value ? 'unshift' : 'push'](function () {
      background = $$value;
      $$invalidate(3, background);
    });
  }

  $$self.$$set = function ($$props) {
    if ('show' in $$props) $$invalidate(22, show = $$props.show);
    if ('key' in $$props) $$invalidate(23, key = $$props.key);
    if ('ariaLabel' in $$props) $$invalidate(24, ariaLabel = $$props.ariaLabel);
    if ('ariaLabelledBy' in $$props) $$invalidate(25, ariaLabelledBy = $$props.ariaLabelledBy);
    if ('closeButton' in $$props) $$invalidate(26, closeButton = $$props.closeButton);
    if ('closeOnEsc' in $$props) $$invalidate(27, closeOnEsc = $$props.closeOnEsc);
    if ('closeOnOuterClick' in $$props) $$invalidate(28, closeOnOuterClick = $$props.closeOnOuterClick);
    if ('styleBg' in $$props) $$invalidate(29, styleBg = $$props.styleBg);
    if ('styleWindowWrap' in $$props) $$invalidate(30, styleWindowWrap = $$props.styleWindowWrap);
    if ('styleWindow' in $$props) $$invalidate(31, styleWindow = $$props.styleWindow);
    if ('styleContent' in $$props) $$invalidate(32, styleContent = $$props.styleContent);
    if ('styleCloseButton' in $$props) $$invalidate(33, styleCloseButton = $$props.styleCloseButton);
    if ('classBg' in $$props) $$invalidate(34, classBg = $$props.classBg);
    if ('classWindowWrap' in $$props) $$invalidate(35, classWindowWrap = $$props.classWindowWrap);
    if ('classWindow' in $$props) $$invalidate(36, classWindow = $$props.classWindow);
    if ('classContent' in $$props) $$invalidate(37, classContent = $$props.classContent);
    if ('classCloseButton' in $$props) $$invalidate(38, classCloseButton = $$props.classCloseButton);
    if ('unstyled' in $$props) $$invalidate(0, unstyled = $$props.unstyled);
    if ('setContext' in $$props) $$invalidate(39, setContext = $$props.setContext);
    if ('transitionBg' in $$props) $$invalidate(40, transitionBg = $$props.transitionBg);
    if ('transitionBgProps' in $$props) $$invalidate(41, transitionBgProps = $$props.transitionBgProps);
    if ('transitionWindow' in $$props) $$invalidate(42, transitionWindow = $$props.transitionWindow);
    if ('transitionWindowProps' in $$props) $$invalidate(43, transitionWindowProps = $$props.transitionWindowProps);
    if ('disableFocusTrap' in $$props) $$invalidate(44, disableFocusTrap = $$props.disableFocusTrap);
    if ('$$scope' in $$props) $$invalidate(46, $$scope = $$props.$$scope);
  };

  $$self.$$.update = function () {
    if ($$self.$$.dirty[0] &
    /*show*/
    4194304 | $$self.$$.dirty[1] &
    /*isMounted*/
    16384) {
      {
        if (isMounted) {
          if (isFunction(show)) {
            open(show);
          } else {
            close();
          }
        }
      }
    }
  };

  return [unstyled, state, Component, background, wrap, modalWindow, cssBg, cssWindowWrap, cssWindow, cssContent, cssCloseButton, currentTransitionBg, currentTransitionWindow, onOpen, onClose, onOpened, onClosed, isFunction, close, handleKeydown, handleOuterMousedown, handleOuterMouseup, show, key, ariaLabel, ariaLabelledBy, closeButton, closeOnEsc, closeOnOuterClick, styleBg, styleWindowWrap, styleWindow, styleContent, styleCloseButton, classBg, classWindowWrap, classWindow, classContent, classCloseButton, setContext, transitionBg, transitionBgProps, transitionWindow, transitionWindowProps, disableFocusTrap, isMounted, $$scope, slots, div1_binding, div2_binding, div3_binding];
}

var Modal = /*#__PURE__*/function (_SvelteComponent) {
  _inherits(Modal, _SvelteComponent);

  var _super = _createSuper(Modal);

  function Modal(options) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this);
    init(_assertThisInitialized(_this), options, instance, create_fragment, safe_not_equal, {
      show: 22,
      key: 23,
      ariaLabel: 24,
      ariaLabelledBy: 25,
      closeButton: 26,
      closeOnEsc: 27,
      closeOnOuterClick: 28,
      styleBg: 29,
      styleWindowWrap: 30,
      styleWindow: 31,
      styleContent: 32,
      styleCloseButton: 33,
      classBg: 34,
      classWindowWrap: 35,
      classWindow: 36,
      classContent: 37,
      classCloseButton: 38,
      unstyled: 0,
      setContext: 39,
      transitionBg: 40,
      transitionBgProps: 41,
      transitionWindow: 42,
      transitionWindowProps: 43,
      disableFocusTrap: 44
    }, add_css, [-1, -1, -1]);
    return _this;
  }

  return _createClass(Modal);
}(SvelteComponent);

export { Modal, bind, Modal as default };